import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { BtnCancel } from "../styles";
import { updateItem } from "../inventory/itemsSlice";
import { mutateItem } from "../inventory/httpCalls";
import { useDispatch } from "react-redux";
import { editSelForPurchase } from "./purchaseSlice";
import CustomInput from "../components/CustomInput";

function EditPrice({ onClose, item }) {
  const dispatch = useDispatch();
  const [price, setPrice] = useState("");

  const handleInput = (e) => {
    const { value } = e.target;
    setPrice(value);
  };

  const handleUpdate = async () => {
    let selected = JSON.parse(JSON.stringify(item));
    selected.companyPrice = state.price;
    dispatch(updateItem(selected));
    dispatch(editSelForPurchase({ _id: selected._id, price: state.price }));
    mutateItem("", selected, "", dispatch);
    onClose();
  };

  const onClear = () => {
    setPrice("");
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing="16px">
          <Typography
            variant="h6"
            sx={{ color: "#4EAF51", textAlign: "center" }}
          >
            Add Company Price
          </Typography>

          <CustomInput
            name="price"
            label="Company Price"
            type="number"
            value={price}
            onChange={handleInput}
            onClear={onClear}
          />

          <Stack direction="row" justifyContent="space-evenly" spacing={5}>
            <BtnCancel fullWidth variant="outlined" onClick={onClose}>
              Cancel
            </BtnCancel>
            <Button fullWidth variant="contained" onClick={handleUpdate}>
              Update
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default EditPrice;
